import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {countriesData, ICountryData} from '../../config/data/countries/countries.data';
import {IStateData, mexicoStatesData} from '../../config/data/states/mexico-states.data';
import {IAddress} from '../../interfaces/address/address.interface';
import {NgForm} from '@angular/forms';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';

@Component({
  selector: 'app-address-section',
  templateUrl: './address-section.component.html',
  styleUrls: ['./address-section.component.scss']
})
export class AddressSectionComponent implements OnInit, AfterViewInit {
  /**
   * Address form
   * @type IAddress
   */
  @Input() address: IAddress;

  /**
   * Required form
   * @type boolean
   * @default true
   */
  @Input() required = true;

  /**
   * Remove class card-container-shadow on the form
   * @type boolean
   * @default false
   */
  @Input() removeClassCardContainerShadow = false;

  /**
   * Show header title
   * @type boolean
   * @default true
   */
  @Input() showHeader = true;

  /**
   * Number of rows to reference field
   */
  @Input() rowsReference = 3;

  @Input() cssLabelClass = 'input-label-form';
  @ViewChild('formAddress') formAddress: NgForm;

  @Input() disabled: boolean;
  // Countries and states
  countries: ICountryData[];
  mexicoStates: IStateData[];

  helperValidationField: HelperValidationField;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  ngAfterViewInit(): void {
    this.init();
  }

  /**
   * Init variables
   * @private
   */
  private init(): void {
    this.countries = countriesData;
    this.mexicoStates = mexicoStatesData;
    const defaultData = {
      city: '',
      cp: '',
      country: 'México',
      suburb: '',
      street: '',
      state: '',
      reference: '',
    };
    this.address = {
      ...defaultData,
      ...this.address
    };
    if (!this.address.country) {
      this.address.country = 'México';
    }
    if (typeof this.address.cp === 'number') {
      this.address.cp = String(this.address.cp);
    }

    this.helperValidationField = new HelperValidationField();
  }

  checkIfFormValid(): void {
    // tslint:disable:no-string-literal
    try {
      this.formAddress.control.markAllAsTouched();
      this.formAddress.control.markAsDirty();
      if (!this.required && !this.formAddress?.control.get('cp').value) {
        this.formAddress?.control.get('cp').setValue(undefined);
        return;
      }
      const valorCpString = String(this.address.cp);
      if (this.helperValidationField.validCPValue(valorCpString)) {
        this.formAddress?.controls['cp']?.setErrors(
          { ...this.formAddress?.controls['cp']?.errors, cpError: { message: this.helperValidationField?.validCPValue(valorCpString) } }
        );
      }
    } catch (e) {
      console.log(e);
    }
  }

  getValue(): IAddress {
    return this.formAddress.form.getRawValue();
  }
}
